export default function Loader() {
  return (
    <div className='ripple-loader'>
      <div className='ripple medium'>
        <div />
        <div />
        <div />
      </div>
    </div>)
}
